import { atom } from 'recoil';

export const onLineState = atom<boolean>({
  key: 'onLineState',
  default: navigator.onLine,
});
